module.exports = __webpack_public_path__ + "img/sdgs_carbon_neutral.d1667ac1.jpeg";